










































































import { Component, Prop, Vue } from 'vue-property-decorator';
import AlpacaBtn from '@/components/AlpacaBtn.vue';
import AlpacaCard from '@/components/AlpacaCard.vue';
import SelectSquadPopup from '@/components/SelectSquadPopup.vue';
import {Alpaca} from '@/backend/type';
import {getQuadAlpacas} from '@/backend/requests';
import {squadInfo} from '@/utils/squad';
import {
  squadPendingAlpa,
  squadClaim,
} from '@/utils/web3';
import BigNumber from 'bignumber.js';
import { ROUTE_ALPACA } from '@/router';

@Component({
  components: {
    AlpacaBtn,
    AlpacaCard,
    SelectSquadPopup,
  },
})
export default class Squad extends Vue {
  public alpaEarned: string = '0';
  public userSquadAlpacas: Alpaca[] | null = null;
  public showSelectPopup: boolean = false;
  public curTab: string = 'assign';
  public userSquadInfo: {weeklyReward: BigNumber; percentage: BigNumber} | null = null;
  public userSquadMemberInfo: any = null;

  get account() {
    return this.$store.getters.getAccount;
  }

  get weeklyReward() {
    if (this.userSquadInfo) {
      return this.$options.filters!.fixedAndComma(this.userSquadInfo.weeklyReward, 2);
    }
    return '-';
  }

  get percentage() {
    if (this.userSquadInfo) {
      return this.$options.filters!.fixedAndComma(this.userSquadInfo.percentage, 2);
    }
    return '-';
  }

  get memberCount() {
    if (this.userSquadMemberInfo) {
      return this.userSquadMemberInfo.total_count;
    }
    return '-';
  }

  get totalEnergy() {
    if (this.userSquadMemberInfo) {
      return this.$options.filters!.numberToBMK(Number(this.userSquadMemberInfo.energies.total_energy), 2);
    }
    return '-';
  }

  get avgEnergy() {
    if (this.userSquadMemberInfo) {
      return this.$options.filters!.fixedAndComma(this.userSquadMemberInfo.energies.avg_energy, 2);
    }
    return '-';
  }

  public mounted() {
    this.getAlpaEarned();
    this.getSquadAlpacas();
    this.getSquadInfo();
  }

  public async getAlpaEarned() {
    const amount = await squadPendingAlpa(this.account);
    if (amount) {
      this.alpaEarned = amount;
    }
  }

  public async getSquadAlpacas() {
    const res = await getQuadAlpacas(this.account, 'energy', -1);
    if (res) {
      this.userSquadAlpacas = res.data.alpacas ? res.data.alpacas : [];
      this.userSquadMemberInfo = res.data;
    } else {
      this.userSquadAlpacas = [];
    }
  }

  public async getSquadInfo() {
    const res = await squadInfo(this.account);
    if (res) {
      this.userSquadInfo = res;
    }
  }

  public handleClaim() {
    squadClaim(this.account);
  }

  public togglePopup(tab: string) {
    this.curTab = tab;
    this.showSelectPopup = !this.showSelectPopup;
  }

  public goAlpacaInfo(alpaca: any) {
    this.$router.push({ name: ROUTE_ALPACA, params: {alpacaID: alpaca.id} });
  }
}
